/**
 * The reason for this custom breakpoint is because we can't show
 * our UI changes for this variant for ABOVE_TABLET (1025px) breakpoint
 * because strevda sidebar disappears at exactly 1090px.
 */
export const TOTAL_TRIP_COST_POSITION_CHANGED_BREAKPOINT =
  '(min-width: 1091px)';
